import React, { useState } from 'react';
import JsonTreeNode from './JsonTreeNode';
import NodeDetailPanel from './NodeDetailPanel';
import ResizableSplitter from './ResizableSplitter';
import { useLanguage } from '../i18n';

const STORAGE_KEY_DETAIL_WIDTH = 'json-tree-detail-width';

/**
 * JSON 树状视图容器组件
 * 用于 JSON 工具 Tab 显示树状结构
 */
function JsonTreeView({ tree, onToggle, selectedNode, onNodeSelect, isInputCollapsed, detailMode }) {
  const { language } = useLanguage();

  // 详情面板的宽度比例（左侧导航占比）
  const [detailNavWidth, setDetailNavWidth] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY_DETAIL_WIDTH);
    return saved ? parseFloat(saved) : 35;
  });

  const [isDragging, setIsDragging] = useState(false);

  // 处理详情面板宽度变化
  const handleDetailResize = (newWidth) => {
    setDetailNavWidth(newWidth);
    localStorage.setItem(STORAGE_KEY_DETAIL_WIDTH, newWidth.toString());
  };

  // 处理拖动状态变化
  const handleDetailDragStateChange = (dragging) => {
    setIsDragging(dragging);
  };
  // 空状态
  if (!tree) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400 dark:text-gray-500 bg-white dark:bg-gray-800">
        <div className="text-center">
          <div className="text-4xl mb-2">🌳</div>
          <div className="text-sm">{language === 'zh' ? '在左侧输入 JSON 数据以查看树状结构' : 'Enter JSON on the left to see tree structure'}</div>
        </div>
      </div>
    );
  }

  // 如果详情模式开启且选中了节点，显示分栏布局（左侧树状导航 + 右侧详情面板）
  if (detailMode && selectedNode) {
    return (
      <div className="flex h-full relative">
        {/* 左侧：树状导航 */}
        <div
          className="overflow-auto p-4 bg-gray-50 dark:bg-gray-900"
          style={{ width: `${detailNavWidth}%`, overscrollBehavior: 'contain' }}
        >
          <JsonTreeNode
            node={tree}
            onToggle={onToggle}
            selectedNodeId={selectedNode?.id}
            onNodeSelect={onNodeSelect}
          />
        </div>

        {/* 可拖动分隔线 */}
        <ResizableSplitter
          leftWidth={detailNavWidth}
          onResize={handleDetailResize}
          onDragStateChange={handleDetailDragStateChange}
          minWidth={20}
          maxWidth={70}
          collapseThreshold={0} // 不允许折叠
        />

        {/* 右侧：详情面板 */}
        <div style={{ width: `${100 - detailNavWidth}%`, overscrollBehavior: 'contain' }}>
          <NodeDetailPanel
            node={selectedNode}
            tree={tree}
            onClose={() => onNodeSelect(selectedNode)} // 再次点击同一个节点会取消选中
          />
        </div>
      </div>
    );
  }

  // 默认：正常显示树状视图
  return (
    <div className="h-full overflow-auto p-4 bg-white dark:bg-gray-800" style={{ overscrollBehavior: 'contain' }}>
      <JsonTreeNode
        node={tree}
        onToggle={onToggle}
        selectedNodeId={detailMode ? selectedNode?.id : null}
        onNodeSelect={onNodeSelect}
      />
    </div>
  );
}

export default JsonTreeView;
